/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUserAgent
 */
export interface ControlUserAgent {
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    browserMajorVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    browserName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    browserVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    cpuArchitecture: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    deviceModel: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    deviceVendor: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    engineName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    engineVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    osName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserAgent
     */
    userAgentAlt: string;
}

/**
 * Check if a given object implements the ControlUserAgent interface.
 */
export function instanceOfControlUserAgent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "browserMajorVersion" in value;
    isInstance = isInstance && "browserName" in value;
    isInstance = isInstance && "browserVersion" in value;
    isInstance = isInstance && "cpuArchitecture" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "deviceModel" in value;
    isInstance = isInstance && "deviceVendor" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "engineName" in value;
    isInstance = isInstance && "engineVersion" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "osName" in value;
    isInstance = isInstance && "osVersion" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "userAgent" in value;
    isInstance = isInstance && "userAgentAlt" in value;

    return isInstance;
}

export function ControlUserAgentFromJSON(json: any): ControlUserAgent {
    return ControlUserAgentFromJSONTyped(json, false);
}

export function ControlUserAgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserAgent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'browserMajorVersion': json['browserMajorVersion'],
        'browserName': json['browserName'],
        'browserVersion': json['browserVersion'],
        'cpuArchitecture': json['cpuArchitecture'],
        'createdAt': json['createdAt'],
        'deviceModel': json['deviceModel'],
        'deviceVendor': json['deviceVendor'],
        'displayName': json['displayName'],
        'engineName': json['engineName'],
        'engineVersion': json['engineVersion'],
        'id': json['id'],
        'osName': json['osName'],
        'osVersion': json['osVersion'],
        'teamId': json['teamId'],
        'userAgent': json['userAgent'],
        'userAgentAlt': json['userAgentAlt'],
    };
}

export function ControlUserAgentToJSON(value?: ControlUserAgent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'browserMajorVersion': value.browserMajorVersion,
        'browserName': value.browserName,
        'browserVersion': value.browserVersion,
        'cpuArchitecture': value.cpuArchitecture,
        'createdAt': value.createdAt,
        'deviceModel': value.deviceModel,
        'deviceVendor': value.deviceVendor,
        'displayName': value.displayName,
        'engineName': value.engineName,
        'engineVersion': value.engineVersion,
        'id': value.id,
        'osName': value.osName,
        'osVersion': value.osVersion,
        'teamId': value.teamId,
        'userAgent': value.userAgent,
        'userAgentAlt': value.userAgentAlt,
    };
}

